import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Graphics } from "constant";

export default class Icon extends Component {
  static propTypes = {
    name: PropTypes.string,
    nameSelected: PropTypes.string,
    selected: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    onClick: PropTypes.func,
    children: PropTypes.any,
    mode: PropTypes.oneOf(["contain", "cover", "auto"])
  };
  static defaultProps = {
    width: 16,
    height: 16,
    mode: "contain"
  };

  render() {
    return <Wrapper {...this.props}>{this.props.children}</Wrapper>;
  }
}

const Wrapper = styled.div`
  display: inline-flex;
  vertical-align: top;
  flex: none;
  background-position: center;
  background-repeat: no-repeat;
  ${props => {
    const iconNormal = Graphics[props.name];
    const backgroundNormal = css`background-image: url(${iconNormal});`;
    const commonStyle = css`
      background-size: ${props.mode};
      width: ${props.width}px;
      height: ${props.height}px;
    `;
    const onClickStyle =
      props.onClick &&
      css`
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      `;

    if (props.nameSelected) {
      const iconSelected = Graphics[props.nameSelected];
      const backgroundSelected = css`background-image: url(${iconSelected});`;

      return css`
        ${commonStyle};
        ${onClickStyle};
        ${props.selected ? backgroundSelected : backgroundNormal};
      `;
    } else {
      return css`
        ${commonStyle};
        ${onClickStyle};
        ${backgroundNormal};
        ${props.selected && "opacity: 0.7"};
      `;
    }
  }};
`;



// WEBPACK FOOTER //
// ./src/module-common/Icon.js